import React, { createContext, useContext, useState, ReactNode } from "react";

interface TaskDialogContextType {
  isOpen: boolean;
  openTaskDialog: () => void;
  closeTaskDialog: () => void;
}

const TaskDialogContext = createContext<TaskDialogContextType | undefined>(
  undefined
);

export const useTaskDialog = () => {
  const context = useContext(TaskDialogContext);
  if (context === undefined) {
    throw new Error("useTaskDialog must be used within a TaskDialogProvider");
  }
  return context;
};

interface TaskDialogProviderProps {
  children: ReactNode;
}

export const TaskDialogProvider: React.FC<TaskDialogProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openTaskDialog = () => setIsOpen(true);
  const closeTaskDialog = () => setIsOpen(false);

  return (
    <TaskDialogContext.Provider
      value={{ isOpen, openTaskDialog, closeTaskDialog }}
    >
      {children}
    </TaskDialogContext.Provider>
  );
};
